import EditIconButton from './component.styles'
export default EditIconButton
